// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class InformationMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_INFORMATION_MESSAGE, fieldSet);
    }
    setMsgType(msgtype) {
        this.setFieldValue(FieldsFactory.FIELD_INFO_MSG_TYPE, msgtype);
    }
    setMsgTypeId(msgtype) {
        this.setFieldValue(FieldsFactory.FIELD_INFO_MSG_TYPE_ID, msgtype);
    }
    setContent(content) {
        this.setFieldValue(FieldsFactory.FIELD_CONTENT, content);
    }
    setTimeSpan(timespan) {
        this.setFieldValue(FieldsFactory.FIELD_TIMESTAMP, timespan);
    }
}
